<template>
    <div class="main-content">
        <div class="row">
            <div
                v-for="report in reports"
                :key="`report-${report.title}`"
                class="col-6 mb-3"
            >
                <router-link v-if="report.to" :to="report.to">
                    <happiness-reports-card :report="report"/>
                </router-link>
                <happiness-reports-card v-else :report="report"/>
            </div>
        </div>
    </div>
</template>

<script>
import HappinessReportsCard from './HappinessReportsCard'
export default {
    name: 'HappinessReports',
    components: {
        HappinessReportsCard,
    },
    data () {
        return {
            reports: [
                /* {
                    title: 'Pontuação por participante ou equipe',
                    img: '',
                }, */
                {
                    title: 'Evolução da pontuação',
                    icon: 'i-Statistic',
                    to: { name: 'ScoreEvolutionReport' },
                },
                {
                    title: 'Evolução da participação',
                    icon: 'i-Checked-User',
                    to: { name: 'ParticipationEvolutionReport' },
                },
                {
                    title: 'Evolução da pontuação por Equipe',
                    icon: 'i-Business-Mens',
                    to: { name: 'ScoreEvolutionReportByTeams' },
                },
                {
                    title: 'Feedbacks',
                    icon: 'i-Speach-Bubble-8',
                    to: { name: 'ReportFeedbacksHome' },
                },
                {
                    title: 'Milestones',
                    icon: 'i-Map-Marker',
                    to: { name: 'ReportMilestones' },
                },
            ],
        }
    },
}
</script>
